// 快速搜索
export const quickSearchList = [
  {
    id: "1",
    name: 'support_home_banner_search_Activities',
    value: 'Activities'
  },
  {
    id: "2",
    name: 'support_home_banner_search_Software',
    value: 'Software'
  },
  {
    id: "3",
    name: 'support_home_banner_search_Hardware',
    value: 'Hardware'
  },
  {
    id: "4",
    name: 'support_home_banner_search_Streaming',
    value: 'Streaming'
  },
  {
    id: "5",
    name: 'support_home_banner_search_Policy',
    value: 'Policy'
  }
]
// 服务推荐
const activationIcon = require('../../pages/outer/support/assets/support_activation.png')
const salesSeviceIcon = require('../../pages/outer/support/assets/support_salesService.png')
const maintenanceIcon = require('../../pages/outer/support/assets/support_queryMaintenance.png')
const questionIcon = require('../../pages/outer/support/assets/support_question.png')
const privacyClauseIcon = require('../../pages/outer/support/assets/support_privacy.png')
export const serviceRecommendList = [
  {
    id: "1",
    icon: activationIcon,
    name:'support_home_service_warranty_query',
    type: 'route', // type: route or link  route=>项目内路由，link=>项目外链接
    path: '/support/activate-benefits'
  },
  {
    id: "2",
    icon: salesSeviceIcon,
    name:'support_home_service_warranty_policy',
    type: 'route',
    path: '/support/after-service'
  },
  {
    id: "3",
    icon: maintenanceIcon,
    name:'support_home_service_spare_parts_price',
    type: 'route',
    path: '/support/maintenance-price'
  },
  {
    id: "4",
    icon: questionIcon,
    name:'support_home_service_FAQs',
    type: 'route',
    path: '/support/faq'
  },
  // {
  //   id: "5",
  //   icon: privacyClauseIcon,
  //   name:'support_home_service_privacy_clause',
  //   type: 'link',
  //   path: 'https://www.picoxr.com/legal/privacy-policy'
  // },
]
// 联系我们
export const concatUsInfo = {
  uk: {
    email: 'support.eur@pico-xr.com',
    phone: '006625660782',
    workingTime: 'Mon-Fri 8:00~17:00(UTC+1)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  es: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  nl: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  fr: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  de: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  it: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  global: {
    email: 'support.eur@pico-xr.com',
    phone: '00493058916141',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+2)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  jp: {
    email: 'support.jp@pico-xr.com',
    phone: '81363731050',
    warrantyPhone: '03-5657-0964',
    workingTime: 'Mon-Sun 10:00~19:00(UTC+9)',
    warrantyTime: 'Mon-Fri  8:30~17:00(UTC+9)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  kr: {
    email: 'support.kr@pico-xr.com',
    phone: '8215336310',
    workingTime: 'Mon-Fri 10:00~19:00(UTC+9)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  my: {
    email: 'support.my@pico-xr.com',
    phone: '601117040071',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+8)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  sg: {
    email: 'support.sg@pico-xr.com',
    phone: '6560197403',
    workingTime: 'Mon-Fri 9:00~18:00(UTC+7)',
    comment: 'support_home_contactUs_hotline_tips'
  },
  th: {
    email: 'support.th@pico-xr.com',
    phone: '6625660782',
    workingTime: 'Mon-Sun 9:00~18:00(UTC+7)',
    comment: 'support_home_contactUs_hotline_tips'
  }
}
// 产品支持-快速开始
const basicInfoIcon = require('../../pages/outer/support/assets/icon-accessory.png')
const machineGuideIcon = require('../../pages/outer/support/assets/icon-interchange.png')
const softwareDownloadIcon = require('../../pages/outer/support/assets/icon-download.png')
const usageGuideIcon = require('../../pages/outer/support/assets/icon-guide.png')
export const productSatrtList = [
  {
    id: '1',
    icon: basicInfoIcon,
    title: 'support_product_basic_info_title',
    desc: 'support_product_basic_info_desc',
    path: '/support/product-parameter'
  },
  {
    id: '2',
    icon: machineGuideIcon,
    title: 'support_product_machine_guide_title',
    desc: 'support_product_machine_guide_desc',
    path: '/support/usage-guide'
  },
  {
    id: '3',
    icon: softwareDownloadIcon,
    title: 'support_product_software_download_title',
    desc: 'support_product_software_download_desc',
    path: 'https://www.picoxr.com/sg/software/pico-vr'
  },
  {
    id: '4',
    icon: usageGuideIcon,
    title: 'support_product_usage_guide_title',
    desc: 'support_product_usage_guide_desc',
    path: '/support/faq'
  }
]
// 服务支持-维修流程
const step1_icon = require('../../pages/outer/support/assets/support_repair_icon1.svg')
const step2_icon = require('../../pages/outer/support/assets/support_repair_icon2.svg')
const step3_icon = require('../../pages/outer/support/assets/support_repair_icon3.svg')
const step4_icon = require('../../pages/outer/support/assets/support_repair_icon4.svg')
const step5_icon = require('../../pages/outer/support/assets/support_repair_icon5.svg')
export const processList = [
  { id: '1',
    icon: step1_icon,
    title: 'support_repair_process_step1',
    info: ['Online: Contact merchant services', 'Offline: Contact dealers']
  },
  {
    id: '2',
    icon: step2_icon,
    title: 'support_repair_process_step2',
    info: ['Online: Contact merchant services', 'Offline: Contact dealers']
  },
  {
    id: '3',
    icon: step3_icon,
    title: 'support_repair_process_step3',
    info: ['Online: Contact merchant services', 'Offline: Contact dealers']
  },
  {
    id: '4',
    icon: step4_icon,
    title: 'support_repair_process_step4',
    info: ['Online: Contact merchant services', 'Offline: Contact dealers']
  },
  {
    id: '5',
    icon: step5_icon,
    title: 'support_repair_process_step5',
    info: ['Online: Contact merchant services', 'Offline: Contact dealers']
  }
]
// 新机入手指南
const cover = require('../../pages/outer/support/assets/support_guide_video_cover.jpg')
export const videoList = [
  {
    id: '1',
    title: 'PICO 4 Startup and Usage Guide.mp4',
    cover,
    url: 'https://pico-web-tob.oss-cn-beijing.aliyuncs.com/20230828/document/1695990872596369408.mp4'
  },
  {
    id: '2',
    title: 'PICO 4 Initial Link Computer Device Installation Guide.mp4',
    cover,
    url: 'https://pico-web-tob.oss-cn-beijing.aliyuncs.com/20230828/document/1695991028880330752.mp4'
  },
  {
    id: '3',
    title: 'PICO 4 Startup and Usage Guide.mp4',
    cover,
    url: 'https://pico-web-tob.oss-cn-beijing.aliyuncs.com/20230828/document/1695991116209934336.mp4'
  }
]
export const docList = [
  {
    id: '1',
    title: 'PICO 4 Startup and Usage Guide.pdf',
    url: 'https://pico-web-tob.oss-cn-beijing.aliyuncs.com/20230825/document/1695015503416348672.pdf',
    size: '3.14M'
  }
]
// 隐私条款
// export const privacyClauseList = [
//   {
//     id: '1',
//     title: 'support_email_us_modal_service_scope',
//     content: 'support_email_us_modal_service_scope_content'
//   },
//   {
//     id: '2',
//     title: 'support_email_us_modal_sales_service',
//     content: 'support_email_us_modal_sales_service_content'
//   },
//   {
//     id: '3',
//     title: 'support_email_us_modal_preparation',
//     content: 'support_email_us_modal_preparation_content'
//   },
//   {
//     id: '4',
//     title: 'support_email_us_modal_solution',
//     content: 'support_email_us_modal_solution_content'
//   }
// ]
